<template>
  <div class="star-rating">
    <a-tooltip v-if="readonly && selectedScore" :title="scoreText" placement="top">
      <a-rate v-model="selectedScore" :disabled="readonly" allow-half :count="5" style="margin-right: 5px" @change="handleChange" />
    </a-tooltip>
    <a-rate v-else v-model="selectedScore" :disabled="readonly" allow-half :count="5" style="margin-right: 5px" @change="handleChange" />
    <span v-if="showText && selectedScore && !readonly" class="rating-text">
      {{ scoreText }}
    </span>
  </div>
</template>

<script>
// 5分制评级标准
const ratingLevels = {
  5: { label: '很好', description: '非常满意' },
  4: { label: '好', description: '比较满意' },
  3: { label: '一般', description: '基本满意' },
  2: { label: '较差', description: '不太满意' },
  1: { label: '差', description: '很不满意' }
};

export default {
  name: 'StarRating',
  props: {
    value: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedScore: this.value || 0
    };
  },
  computed: {
    scoreText() {
      if (!this.selectedScore) return '';

      const integerPart = Math.ceil(this.selectedScore);
      const level = ratingLevels[integerPart];

      if (level) {
        return `    ${this.selectedScore}分（${level.label}）`;
      }

      return `  ${this.selectedScore}分`;
    }
  },
  watch: {
    value(newVal) {
      this.selectedScore = newVal || 0;
    }
  },
  methods: {
    handleChange(value) {
      this.selectedScore = value;
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>

<style lang="less" scoped>
.star-rating {
  display: flex;
  align-items: center;
}
</style>
